'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.component('mdi-fish-icon', {
  template: '<svg :class="[\'mdi-icon\', className]" :width="width" :height="height" :viewBox="viewBox"><path  d="M 12,20L 12.7554,16.9784C 9.51828,16.791 6.59333,15.4026 5.74592,13.5762C 5.66483,14.0557 5.52729,14.4939 5.33333,14.8333C 4.66666,16 3.33333,16 2,16C 3.10457,16 3.5,14.433 3.5,12.5C 3.5,10.567 3.10457,9.00001 2,9.00001C 3.33333,9.00001 4.66666,9.00001 5.33333,10.1667C 5.5273,10.5061 5.66483,10.9443 5.74592,11.4238C 6.40461,10.0041 8.3185,8.84915 10.6585,8.31709L 9,5.00001C 11,5.00001 13,5.00001 14.3333,5.66667C 15.459,6.2295 16.1095,7.26748 16.6859,8.37948C 19.6091,9.07648 22,10.6592 22,12.5C 22,14.3795 19.5076,15.9899 16.501,16.6633C 15.6714,17.7591 14.8612,18.7777 14.1667,19.3333C 13.3333,20 12.6667,20 12,20 Z M 17,11C 16.4477,11 16,11.4477 16,12C 16,12.5523 16.4477,13 17,13C 17.5523,13 18,12.5523 18,12C 18,11.4477 17.5523,11 17,11 Z "/></svg>',
  props: {
    className: [Object, Array, String],
    width: {
      type: Number,
      'default': 24
    },
    height: {
      type: Number,
      'default': 24
    },
    viewBox: {
      type: String,
      'default': '0 0 24 24'
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/mdi-vue/FishIcon.js
// module id = lV8A
// module chunks = 0